export default __webpack_public_path__ + "static/media/xmark.75293a67.svg";